const PATH = 'fe.components.recertification_product_key.confirmation_modal';

const messages = {
  certifications: {
    key: `${PATH}.certifications`,
    defaultValue: 'Certifications:'
  },
  language: {
    key: `${PATH}.language`,
    defaultValue: 'Language:'
  },
  warningTitle: {
    key: `${PATH}.warning_title`,
    defaultValue: 'Warning:'
  },
  notChosenTitle: {
    key: `${PATH}.not_chosen_title`,
    defaultValue: 'Certifications you did not choose to renew:'
  },
  notChosenConfirm: {
    key: `${PATH}.not_chosen_confirm`,
    defaultValue: 'Are you sure you still want this option?'
  },
  pairedTrainerWarning: {
    key: `${PATH}.paired_trainer_warning`,
    defaultValue:
      'You have {{certificationNames}} in renewable status. Are you sure you want to renew only your Observer certification? To renew your trainer certification(s) too, cancel and use the trainer recertification token instead.'
  }
};

export default messages;
